import { type Channel, ProductType } from "@/api_client";
import { ChildEntryForm } from "@/components/products/child/entry/ChildEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import type { Locales } from "@/graphql/generated";
import { useEntryContentExternal } from "@/services/cms/tanstackQuery/hooks/useEntryContentExternal";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type ChildEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function ChildEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<ChildEntryProps>) {
  const { isLoading, isSubmitting, submitEntryHandler, policyHolder, user } =
    useEntryForWebComponents({
      productType: "child",
      backendHost,
      appPathPrefix,
      skipCart,
      channel,
      language,
    });

  const { data: content, isLoading: isLoadingContent } =
    useEntryContentExternal({
      product: ProductType.CHILD,
      language: language as Locales,
      appPathPrefix,
    });

  if (isLoading || isLoadingContent) return <ProductContainer.Loader />;

  return (
    <ChildEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
